/*
  The Toggle Button component is a switch that alternate between returning a true or false value
*/

import React from 'react';

import BaseComponent from '../../../baseClasses/BaseComponent'; 
import './ToggleButton.scss';

class ToggleButton extends BaseComponent {

  handleSwitchClick(e){
    e.stopPropagation();
    const{ handleClick } = this.props;
    if (handleClick){
      handleClick(!this.props.selected,);
    }
  }

  render() {
    let { 
      left, 
      top, 
      right, 
      bottom, 
      position,
      selected,
    } = this.props;

    let style = {};

    if (left){
      style.left = left;
    }
    if (top){
      style.top = top;
    }
    if (right){
      style.right = right;
    }
    if (bottom){
      style.bottom = bottom;
    }
    if (position){
      style.position = position;
    }

    return (
      <label className={'toggle-button' + (this.props.readOnly ? ' read-only': '')} style={style}>
        <input onChange={this.handleSwitchClick} type="checkbox" checked={selected} disabled={this.props.readOnly} value={selected}/>
        <span className={'slider round' + (this.props.readOnly ? ' read-only': '')}></span>
      </label>
    );
  }
}

export default (ToggleButton);



// WEBPACK FOOTER //
// ./src/components/Buttons/ToggleButton/index.js